module.exports = [
  {
    "COD": "Heart Disease",
    "Geography": "Metro New Orleans",
    "Year": "1999-2001",
    "Rate": 175.1
  },
  {
    "COD": "Heart Disease",
    "Geography": "Metro New Orleans",
    "Year": "2002-2004",
    "Rate": 151.9
  },
  {
    "COD": "Heart Disease",
    "Geography": "Metro New Orleans",
    "Year": "2005-2007",
    "Rate": 133.3
  },
  {
    "COD": "Heart Disease",
    "Geography": "Metro New Orleans",
    "Year": "2008-2010",
    "Rate": 111.57
  },
  {
    "COD": "Heart Disease",
    "Geography": "Metro New Orleans",
    "Year": "2011-2013",
    "Rate": 90.93
  },
  {
    "COD": "Heart Disease",
    "Geography": "Metro New Orleans",
    "Year": "2014-2016",
    "Rate": 78.03
  },
  {
    "COD": "Heart Disease",
    "Geography": "Metro New Orleans",
    "Year": "2017-2018",
    "Rate": 74.55
  },
  {
    "COD": "Heart Disease",
    "Geography": "United States",
    "Year": "1999-2001",
    "Rate": 186.8
  },
  {
    "COD": "Heart Disease",
    "Geography": "United States",
    "Year": "2002-2004",
    "Rate": 164.1
  },
  {
    "COD": "Heart Disease",
    "Geography": "United States",
    "Year": "2005-2007",
    "Rate": 138.57
  },
  {
    "COD": "Heart Disease",
    "Geography": "United States",
    "Year": "2008-2010",
    "Rate": 119.13
  },
  {
    "COD": "Heart Disease",
    "Geography": "United States",
    "Year": "2011-2013",
    "Rate": 105.73
  },
  {
    "COD": "Heart Disease",
    "Geography": "United States",
    "Year": "2014-2016",
    "Rate": 96.77
  },
  {
    "COD": "Heart Disease",
    "Geography": "United States",
    "Year": "2017-2018",
    "Rate": 91.9
  }
]
